import { UPDATE_AVAILABILITY_STATUS } from '../actions';

export const availabilityStatus = (state = null, action) => {
  switch (action.type) {
    case UPDATE_AVAILABILITY_STATUS: {
      return action.availabilityStatus;
    }
    default:
      return state;
  }
};
